import { useQuery } from "react-query";

import { BAAResponse } from "../types";
import { makeRequest } from "../../util";

export default function useFetchBAA(siteDomain: string, trackerDomain: string) {
  return useQuery(`baa-${siteDomain}-${trackerDomain}`, async () => {
    const res = await makeRequest<BAAResponse>(
      "get_baa",
      { siteDomain, trackerDomain },
      {
        validateStatus: (status) => status === 200 || status === 404,
      }
    );

    if (res.status === 404) {
      return undefined;
    }

    return {
      webTrackerBAA: {
        ...res.data.webTrackerBAA,
        uploadedAt: new Date(res.data.webTrackerBAA.uploadedAt),
      },
      downloadLink: res.data.downloadLink,
    };
  });
}
